import React, {useEffect} from 'react';
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
// import RegistrationForm from '../components/common/RegistrationForm'


// import mcDonaldsLogo from '../assets/images/mc-donalds.png';
// import myokaLogo from '../assets/images/myoka.png';
// import skySpiritLogo from '../assets/images/sky-spirit.png';


function UkFeatures({

}) {


  return (

    <div className="py-12">
      <div className="max-w-xl mx-auto px-4 sm:px-6 lg:max-w-screen-xl lg:px-8">

        <div className="relative">
          <h3 className="text-center text-3xl leading-8 font-extrabold tracking-tight text-white sm:text-4xl sm:leading-10">
           { /*<img className="h-9 sm:h-10" src={MaltaFlag} alt="Maltese Flag"/> */}
            UK Centric
          </h3>
          <p className="mt-4 max-w-3xl mx-auto text-center text-xl leading-7 text-gray-300">
            The United Kingdom's Tax & Payroll requirements are the core of our payroll solution
          </p>
        </div>

        <div className="lg:grid lg:grid-cols-3 lg:gap-8 relative mt-12 lg:mt-24 ">
          <div>
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
              {/* Heroicon name: lightning-bolt */} 
              <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
              </svg>
            </div>
            <div className="mt-5">
              <h5 className="text-lg leading-6 font-medium text-white">RTI and HMRC</h5>
              <p className="mt-2 text-base leading-6 text-gray-300">
                Worried about HMRC compliance, don't be. Buddy sends HMRC Real Time Information (RTI) everytime you pay your salaries.
              </p>
            </div>
          </div>
          <div className="mt-10 lg:mt-0">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 9a2 2 0 10-4 0v5a2 2 0 01-2 2h6m-6-4h4m8 0a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div className="mt-5">
              <h5 className="text-lg leading-6 font-medium text-white">National Minimum/Living Wage Updates</h5>
              <p className="mt-2 text-base leading-6 text-gray-300">
                We annually guide you through the wage increases, and draw your attention to employees that are moving across brackets through the year.
              </p>
            </div>
          </div>
          <div className="mt-10 lg:mt-0">
            <div className="flex items-center justify-center h-12 w-12 rounded-md bg-orange-500 text-white">
              {/* Heroicon name: scale */} 
              <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
              </svg>
            </div>
            <div className="mt-5">
              <h5 className="text-lg leading-6 font-medium text-white">Legal Updates Included</h5>
              <p className="mt-2 text-base leading-6 text-gray-300">
                Changes in law or tax brackets are updated by our team so you can't get them wrong.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UkFeatures) 
